(() => {
  if (typeof window.theme.wishlist == 'undefined') {
    window.theme.wishlist = {};
  }
  window.theme.wishlist.swat = window.theme.wishlist.swat || null;

  function getVariantInfo(variants) {
    try {
      let variantKeys = variants && variants != '[]' ? Object.keys(JSON.parse(variants)[0]) : [],
        variantinfo;
      if (variantKeys.length > 0) {
        variantinfo = variantKeys[0];
        if (variantinfo == 'Default Title') {
          variantinfo = '';
        }
      } else {
        variantinfo = '';
      }
      return variantinfo;
    } catch (err) {
      return variants;
    }
  }

  function swymGetProductsMarkup(products) {
    let markup = ``;
    products.forEach((product) => {
      // if (!product.iu) console.error(product);
      
      const productUrl = product.du;
      const variantId = product.epi;
      const productId = product.empi;
      const featuredImg = product.iu?.replace(/_\d\d\dx\d\d\d/, ''); // remove fixed size "_620x620"
      const moneyPrice = Shopify.theme.helpers.formatMoney(product.pr);
      const productTitle = product.dt;
      const title_arr = productTitle.split(' ');
      const title_line_main = title_arr[0];
      const title_line_second = title_arr.slice(1).join(' ');

      const secondaryImg = null;
      const sizeVariants = null;
      const moneyCompareAtPrice = null;
      const colorVariants = null;
      const variantInfo = product.variantinfo;

      markup += `
      <li class="grid__item" data-variant-card="unchecked" data-product-id="${productId}" data-variant-id="${variantId}">
        <product-card context="wishlist" class="card-wrapper product-card-wrapper">
          <div
            class="card card--compact-small card--standard card--media"
            style="--ratio-percent: ${1 / window.themeSettings.cardImageRatio * 100}%;"
          >
            <div class="card__inner color-background-2 gradient ratio">
              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  ${
                    secondaryImg
                      ? html`
                          <img
                            srcset="
                              ${featuredImg}&width=165   165w,
                              ${featuredImg}&width=360   360w,
                              ${featuredImg}&width=400   400w,
                              ${featuredImg}&width=450   450w,
                              ${featuredImg}&width=533   533w,
                              ${featuredImg}&width=600   600w,
                              ${featuredImg}&width=720   720w,
                              ${featuredImg}&width=940   940w,
                              ${featuredImg}&width=1066 1066w,
                              ${featuredImg}&width=1200 1200w
                            "
                            src="${featuredImg}"
                            sizes="(min-width: 990px) 25vw, calc((100vw - 48px) / 2)"
                            alt="${productTitle}"
                            class="motion-reduce media__tag"
                            loading="lazy"
                            width="1365"
                            height="2048"
                          />
                        `
                      : ``
                  }
                  ${
                    secondaryImg
                      ? html`
                          <img
                            srcset="
                              ${secondaryImg}&width=165   165w,
                              ${secondaryImg}&width=360   360w,
                              ${secondaryImg}&width=400   400w,
                              ${secondaryImg}&width=450   450w,
                              ${secondaryImg}&width=533   533w,
                              ${secondaryImg}&width=600   600w,
                              ${secondaryImg}&width=720   720w,
                              ${secondaryImg}&width=940   940w,
                              ${secondaryImg}&width=1066 1066w,
                              ${secondaryImg}&width=1200 1200w
                            "
                            src="${secondaryImg}"
                            sizes="(min-width: 990px) 25vw, calc((100vw - 48px) / 2)"
                            alt="${productTitle}"
                            class="motion-reduce media__tag"
                            loading="lazy"
                            width="1365"
                            height="2048"
                          />
                        `
                      : ``
                  }
                </div>
              </div>
              <div class="card__content">
                <div class="card__information">
                  <div class="card-information-top">
                    <p class="h4 card__heading">
                      <a href="${productUrl}">${title_line_main} <span class="visually-hidden">${title_line_second}${
        variantInfo ? `- ${variantInfo}` : ``
      }</span></a>
                    </p>
                    <div class="card_under-heading">
                      <p class="card__subheading">${title_line_second}${variantInfo ? `- ${variantInfo}` : ``}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card__content">
              <div class="quick-add no-js-hidden card-show-on-hover">
                <quick-buy variant-ids="${variantId}" data-via="wishlist">
                  <button class="quick-add__submit button button--full-width" hidden>
                    <span data-atc-label>Add to cart</span>
                    <div class="loading-overlay__spinner hidden">
                      <svg aria-hidden="true" focusable="false" class="spinner"><use href="#icon-spinner"></use></svg>
                    </div>  
                  </button>
                </quick-buy>
              </div>
              <div class="quick-add quick-add--mobile no-js-hidden">
                <quick-buy variant-ids="${variantId}" data-via="wishlist">
                  <button class="quick-add__submit button button--full-width" hidden>
                    <span data-atc-label>Add to cart</span>
                    <div class="loading-overlay__spinner hidden">
                      <svg aria-hidden="true" focusable="false" class="spinner"><use href="#icon-spinner"></use></svg>
                    </div>
                  </button>
                </quick-buy>
              </div>
              <div class="card__information">
                <div class="card-information-top">
                  ${
                    colorVariants
                      ? html`
                          <div class="card__swatches-mobile">
                            <ul class="list-unstyled flex-row">
                              ${colorVariants?.map((variant) => {
                                const color = variant.metafields.filter?.colour?.value[0];
                                const colorHandle = color.toLowerCase().trim();
                                return html`
                                  <li>
                                    <a href="${variant.link}" class="color-swatch swatch-color-${colorHandle}">
                                      <span class="visually-hidden">${color}</span>
                                    </a>
                                  </li>
                                `;
                              })}
                            </ul>
                          </div>
                        `
                      : ``
                  }

                  <h4 class="card__heading h6">
                    <a href="${productUrl}" class="full-unstyled-link">${title_line_main} <span class="visually-hidden">${title_line_second}${
        variantInfo ? ` - ${variantInfo}` : ``
      }</span></a>
                  </h4>
                  <div class="card_under-heading">
                    <p class="card__subheading">${title_line_second}${variantInfo ? ` - ${variantInfo}` : ``}</p>
                    ${
                      colorVariants
                        ? html`
                            <div class="card__swatches">
                              <ul class="color-swatches">
                                ${colorVariants?.map((variant) => {
                                  const color = variant.metafields.filter?.colour?.value[0];
                                  const colorHandle = color.toLowerCase().trim();
                                  return html`
                                    <li>
                                      <a
                                        href="${variant.link}"
                                        class="color-swatch swatch-color-${colorHandle}"
                                        data-swatch-link
                                      >
                                        <span class="visually-hidden">${color}</span>
                                      </a>
                                    </li>
                                  `;
                                })}
                              </ul>
                            </div>
                          `
                        : ``
                    }
                  </div>
                </div>
                <div class="card-information">
                  <span class="caption-large light"></span>
                  <div class="price">
                    <div class="price__container">
                      <div class="price__regular">
                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                        <span class="price-item price-item--regular">${moneyPrice}</span>
                      </div>
                      <div class="price__sale">
                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                        <span>
                          <s class="price-item price-item--regular">${moneyCompareAtPrice}</s>
                        </span>
                        <span class="visually-hidden visually-hidden--inline">Sale price</span>
                        <span class="price-item price-item--sale price-item--last">${moneyPrice}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </product-card>
      </li>
    `;
    });

    return markup;
  }

  function swymAddFullProductCard(containerEl, product) {
    const variantCardEl = containerEl.querySelector(`[data-variant-card="unchecked"][data-product-id="${product.id}"]`);
    if (!variantCardEl) return;
    const atc = variantCardEl.querySelector(`quick-buy`);
    const atcBtns = variantCardEl.querySelectorAll(`quick-buy button`);
    const variantId = parseInt(atc.getAttribute('variant-ids'));
    const variant = product.variants.find((x) => x.id === variantId);
    if (variant.available === false) {
      atcBtns.forEach((x) => (x.disabled = true));
      atcBtns.forEach((x) => (x.querySelector('[data-atc-label]').textContent = window.variantStrings.soldOut));
    }
    atcBtns.forEach((x) => (x.hidden = false));
    variantCardEl.setAttribute('data-variant-card', 'checked');

    const productCardMarkup = window.Shopify.theme.helpers.getProductCardMarkup(product, variant, 'wishlist');
    variantCardEl.innerHTML = productCardMarkup;
    variantCardEl.querySelector(`quick-buy[variant-ids="${variantId}"] button`).classList.add('is-selected');
    variantCardEl.removeAttribute('data-variant-card');
    variantCardEl.setAttribute('data-product-card', true);

    variantCardEl.querySelector('.card-wrapper').innerHTML += html`
      <wishlist-checkbox
        class="wishlist-card-checkbox"
        variant-id="${variantId}"
        product-id="${product.id}"
        product-handle="${product.handle}"
        product-image="${product.featured_image}"
      >
        <button class="button-checkbox">
          <span class="visually-hidden">${window.wishlistSettings.checkboxLabel}</span>
        </button>
      </wishlist-checkbox>
    `;
  }

  function swymEnhanceProductCards(containerSelector, products) {
    const containerEl = document.querySelector(containerSelector);

    products.forEach((product) => {
      const productUrl = product.du.split('?')[0]; // remove any variant string from URL
      fetch(`${productUrl}.js`)
        .then((response) => response.json())
        .then((product) => {
          swymAddFullProductCard(containerEl, product);
        });
    });
  }

  function swymRenderProducts(containerSelector, products) {    
    const searchObj = window.Shopify.theme.helpers.getUrlSearchObj();
    const sortOption = searchObj.sort_by;
    let activeLabel = '';

    if (searchObj && sortOption) {
      console.log('sortOption', sortOption);
      switch (sortOption) {
        case 'price-ascending':
          products.sort((a, b) => parseInt(a.pr) - parseInt(b.pr));
          break;
        case 'price-descending':
          products.sort((a, b) => parseInt(b.pr) - parseInt(a.pr));
          break;
        case 'created-ascending':
          products.sort((a, b) => parseInt(a.empi) - parseInt(b.empi));
          break;
        case 'created-descending':
          products.sort((a, b) => parseInt(b.empi) - parseInt(a.empi));
          break;
        default:
          break;
      }

      const sortMenuOpts = document.querySelectorAll('[data-sort-value]');
      const sortActive = document.querySelector('[data-active-sort]');

      for (const opt of sortMenuOpts) {
        if (opt.getAttribute('data-sort-value') === sortOption) {
          opt.querySelector('[data-active-caret]').hidden = false;
          opt.classList.add('disclosure__link--active');
          // activeLabel = opt.innerText;
          sortActive.innerText = opt.innerText.trim();
        } else {
          opt.querySelector('[data-active-caret]').hidden = true;
          opt.classList.remove('disclosure__link--active');
        }
      }
    }
    const container = document.querySelector(containerSelector);
    const productsMarkup = swymGetProductsMarkup(products);
    clearWishlistContainerItems(container);
    hideWishlistPageCookieNotice(container);
    container.insertAdjacentHTML('beforeend', productsMarkup);
    swymEnhanceProductCards(containerSelector, products);
  }

  function clearWishlistContainerItems(containerEl) {
    if (!containerEl) {
      return;
    }
    containerEl.querySelectorAll(':scope > li:not([data-wishlist-cookie-notice-block])').forEach((li) => {
      li.remove();
    });
  }

  function hideWishlistPageCookieNotice(containerEl) {
    const cookieBlock = containerEl?.querySelector('[data-wishlist-cookie-notice-block]');
    if (cookieBlock) {
      cookieBlock.hidden = true;
    }
  }

  function preferencesCookiesNotAllowed() {
    if (typeof window.theme?.wishlist?.preferencesCookiesNotAllowed === 'function') {
      return window.theme.wishlist.preferencesCookiesNotAllowed();
    }
    return (
      typeof Shopify !== 'undefined' &&
      Shopify.customerPrivacy &&
      typeof Shopify.customerPrivacy.preferencesProcessingAllowed === 'function' &&
      Shopify.customerPrivacy.preferencesProcessingAllowed() === false
    );
  }

  function swymShowCookieConsentPageMessage(containerEl) {
    const collectionEl = containerEl.closest('.collection');
    if (collectionEl) {
      collectionEl.classList.remove('loading');
    }

    document.body.classList.add('is-wishlist-empty');

    const cookieBlock = containerEl.querySelector('[data-wishlist-cookie-notice-block]');
    if (cookieBlock) {
      containerEl.querySelectorAll(':scope > li:not([data-wishlist-cookie-notice-block])').forEach((li) => {
        li.hidden = true;
      });
      cookieBlock.hidden = false;
    }

    if (typeof window.theme?.wishlist?.watchCookieConsentForReload === 'function') {
      window.theme.wishlist.watchCookieConsentForReload();
    }
  }

  function swymEmptyMessage(containerEl) {
    document.body.classList.add('is-wishlist-empty');

    let markup = `
      <li class="wishlist-empty-message is-empty">
        <div class="cart-drawer__empty-content">
           <h2 class="h3 cart__empty-text">${window.wishlistSettings.emptyHtml}</h2>
          <div class="drawer__suggestions">
            <p>
              <a href="${window.wishlistSettings.emptyLink1}" class="button button--tertiary scroll-trigger scroll-trigger--onscreen" aria-label="${window.wishlistSettings.emptyLinkLabel1}" style="--animation-delay: 0;">
                <span aria-hidden="">
                  <span>
                    <span>${window.wishlistSettings.emptyLinkLabel1}</span>
                    <span>${window.wishlistSettings.emptyLinkLabel1}</span>
                  </span>
                </span>
              </a>
            </p>
            <p>
              <a href="${window.wishlistSettings.emptyLink2}" class="button button--tertiary scroll-trigger scroll-trigger--onscreen" aria-label="${window.wishlistSettings.emptyLinkLabel2}" style="--animation-delay: 1;">
                <span aria-hidden="">
                  <span>
                    <span>${window.wishlistSettings.emptyLinkLabel2}</span>
                    <span>${window.wishlistSettings.emptyLinkLabel2}</span>
                  </span>
                </span>
              </a>
            </p>
            <p>
              <a href="${window.wishlistSettings.emptyLink3}" class="button button--tertiary scroll-trigger scroll-trigger--onscreen" aria-label="${window.wishlistSettings.emptyLinkLabel3}" style="--animation-delay: 2;">
                <span aria-hidden="">
                  <span>
                    <span>${window.wishlistSettings.emptyLinkLabel3}</span>
                    <span>${window.wishlistSettings.emptyLinkLabel3}</span>
                  </span>
                </span>
              </a>
            </p>
          </div>
        </div>
      </li>
    `;
    clearWishlistContainerItems(containerEl);
    hideWishlistPageCookieNotice(containerEl);
    containerEl.insertAdjacentHTML('beforeend', markup);
  }

  function swymRenderHome(swat) {
    window.theme.wishlist.swat = swat;
    const containerEl = document.querySelector('#wishlist-items-container-home');

    const onSuccess = function (lists) {
      if (!lists.length) {
        return swymEmptyMessage(containerEl);
      }

      document.body.classList.remove('is-wishlist-empty');

      const allPromo = document.querySelector('.wishlist-all-cta');
      if (allPromo) {
        allPromo.hidden = false;
      }

      let markup = ``;
      const imageSizeRegExp = /_\d\d\dx\d\d\d/; // remove fixed size "_620x620"
      const listName = window.wishlistSettings.allPageTitle;
      const listUrl = window.wishlistSettings.listPageUrl;
      let varIds = [];
      let imgSrcs = [];
      lists.forEach((x) => {
        varIds.push(...x.listcontents.map((x) => x.epi));
        imgSrcs.push(...x.listcontents.filter(x => !!x).map((x) => x.iu));
      });
      varIds = new Set(varIds);
      imgSrcs = Array.from(new Set(imgSrcs)).reverse().filter(x => !!x).slice(0, 4);
      const listItems = varIds.size;

      markup += `
        <li class="wishlist-list-summary">
          <div class="wishlist-list-summary__info">
            <h2 class="h1 lh-zero"><a href="${listUrl}">${listName}</a></h2>
            <p class="medium-hide large-up-hide link-button-caps link-button-noul"><a href="${listUrl}">${listItems} items</a></p>
            <p class="small-hide link-button-caps link-button"><a href="${listUrl}">
              <span hover-inherit class="mask-text scroll-trigger scroll-trigger--onscreen">
                <span>
                  <span class="mask-text__mask">
                    <span>View ${listItems} items</span>
                    <span>View ${listItems} items</span>
                  </span>
                </span>
              </span>            
            </a></p>
          </div>
          <a class="wishlist-list-summary__images" href="${listUrl}">
            ${imgSrcs
              ?.map((imgSrc) => {
                imgSrc = imgSrc.replace(/_\d\d\dx\d\d\d/, '') // remove fixed size "_620x620"
                return `
                <div>
                  <img
                    srcset="
                      ${imgSrc}&width=165   165w,
                      ${imgSrc}&width=360   360w,
                      ${imgSrc}&width=600   600w,
                      ${imgSrc}&width=720   720w,
                      ${imgSrc}&width=940   940w,
                      ${imgSrc}&width=1066 1066w
                    "
                    src="${imgSrc}"
                    sizes="(min-width: 990px) 25vw, calc((100vw - 48px) / 4)"
                    alt=""
                    class="motion-reduce media__tag"
                    loading="lazy"
                    width="1365"
                    height="2048"
                  />
                </div>
              `;
              })
              .join('')}
          </a>
        </li>`;

      lists.forEach((list) => {
        console.log(list);
        
        const listName = list.lname;
        const listId = list.lid;
        const listUrl = `${window.wishlistSettings.listPageUrl}?listId=${listId}`;
        const listItems = list.cnt;
        const imgSrcs = Array.from(new Set(list.listcontents.map((x) => x.iu?.replace(imageSizeRegExp, '')))).filter(x => !!x).slice(
          0,
          4
        );

        markup += `
        <li class="wishlist-list-summary">
          <div class="wishlist-list-summary__info">            
            <h2 class="h1 lh-zero"><a href="${listUrl}">${listName}</a></h2>
            <p class="medium-hide large-up-hide link-button-caps link-button-noul"><a href="${listUrl}">${listItems} items</a></p>
            <p class="small-hide link-button-caps link-button"><a href="${listUrl}">
              <span hover-inherit class="mask-text scroll-trigger scroll-trigger--onscreen">
                <span>
                  <span class="mask-text__mask">
                    <span>View ${listItems} items</span>
                    <span>View ${listItems} items</span>
                  </span>
                </span>
              </span>            
            </a></p>
            
            <wishlist-share class="no-js-hidden" list-id="${listId}" list-name="${listName}">
              <button type="button" class="wishlist-list-summary__share link-button-caps link-button">
                <span hover-inherit class="mask-text scroll-trigger scroll-trigger--onscreen">
                  <span>
                    <span class="mask-text__mask">
                      <span>${window.wishlistSettings.shareList}</span>
                      <span>${window.wishlistSettings.shareList}</span>
                    </span>
                  </span>
                </span>
                <svg class="icon icon-share-2" aria-hidden="true" focusable="false">
                  <use href="#icon-share-2">
                </svg>
              </button>
            </wishlist-share>
          </div>
          <a href="${listUrl}" class="wishlist-list-summary__images">
            ${imgSrcs
              ?.map((imgSrc) => {
                return (!imgSrc) ? `` : `
                <div>
                  <img
                    srcset="
                      ${imgSrc}&width=165   165w,
                      ${imgSrc}&width=360   360w,
                      ${imgSrc}&width=600   600w,
                      ${imgSrc}&width=720   720w,
                      ${imgSrc}&width=940   940w,
                      ${imgSrc}&width=1066 1066w
                    "
                    src="${imgSrc}"
                    sizes="(min-width: 990px) 25vw, calc((100vw - 48px) / 4)"
                    alt=""
                    class="motion-reduce media__tag"
                    loading="lazy"
                    width="1365"
                    height="2048"
                  />
                </div>
              `;
              })
              .join('')}
          </a>
        </li>`;
      });
      clearWishlistContainerItems(containerEl);
      hideWishlistPageCookieNotice(containerEl);
      containerEl.insertAdjacentHTML('beforeend', markup);
    };

    let onError = function (error) {
      console.error('Error response from swat.fetchLists');
      console.error(error);
    };

    if (window.theme.wishlist.isFetching) {
      document.addEventListener(
        'lists-fetched',
        () => {
          onSuccess(window.theme.wishlist.lists);
        },
        { once: true }
      );
    } else if (window.theme.wishlist.lists) {
      onSuccess(window.theme.wishlist.lists);
    } else {
      console.debug('swat.fetchLists');
      swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError,
      });
    }
  }

  const swymFormatProducts = function (productsArr) {
    return productsArr.map(function (p) {
      p.variantinfo = p.vi ? getVariantInfo(p.vi) : '';
      return p;
    });
  };

  const onSuccessAll = function (lists) {
    const products = [];
    const varIds = new Set();
    for (const list of lists) {
      for (const item of list.listcontents) {
        if (!Array.from(varIds).includes(item.epi)) {
          products.push(item);
          varIds.add(item.epi);
        }
      }
    }

    if (!products.length) {
      return swymEmptyMessage(document.querySelector('#wishlist-items-container-all'));
    }

    document.body.classList.remove('is-wishlist-empty');

    const pageTitleEl = document.querySelector('[data-wishlist-page-title]');
    pageTitleEl.innerText = window.wishlistSettings.allPageTitle;
    const formattedProducts = swymFormatProducts(products);
    swymRenderProducts('#wishlist-items-container-all', formattedProducts);
  };

  const onListSuccess = function (listObj) {
    console.log('Fetched list', listObj);

    const pageTitleEl = document.querySelector('[data-wishlist-page-title]');
    pageTitleEl.innerText = listObj.list.lname;
    window.wishlistSettings.listName = listObj.list.lname;

    const formattedProducts = swymFormatProducts(listObj.items);
    swymRenderProducts('#wishlist-items-container-all', formattedProducts);
  };

  const onSharedListSuccess = function (listObj) {
    console.log('Fetched list', listObj);

    const pageTitleEl = document.querySelector('[data-wishlist-page-title]');
    pageTitleEl.innerText = listObj.list.lname;
    window.wishlistSettings.listName = listObj.list.lname;

    for (const elToHide of document.querySelectorAll('[data-wishlist-back]')) {
      elToHide.hidden = true;
    }
    // Swish doesn't return the owner's name; the share link carries the sharer's first name as "by"
    const listAuthor = window.Shopify.theme.helpers.getUrlSearchObj()?.by;
    const headerText = document.querySelector('.collection-hero__text-wrapper');
    if (listAuthor && headerText) {
      const headerSubtitle = html`
        <div class="collection-hero__description center h4 h4-alt">
          <p>${window.wishlistSettings.sharedSubtitle.replace('{{ author }}', '<strong></strong>')}</p>
        </div>
      `;
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = headerSubtitle;
      const headerSubtitleEL = tempDiv.firstElementChild;
      headerSubtitleEL.querySelector('strong').textContent = listAuthor;
      headerText.appendChild(headerSubtitleEL);
    }

    const formattedProducts = swymFormatProducts(listObj.items);
    swymRenderProducts('#wishlist-items-container-all', formattedProducts);
  };

  function updateSearchLinks() {
    const currentSearchParams = new URLSearchParams(window.location.search);
    const sortOptLinks = document.querySelectorAll('[data-sort-value]');
    for (const opt of sortOptLinks) {
      currentSearchParams.set('sort_by', opt.dataset.sortValue);
      opt.setAttribute('href', `?${currentSearchParams.toString()}`);
    }
  }

  function swymRenderAll(swat) {
    window.theme.wishlist.swat = swat;
    let onError = function (error) {
      console.error('Error while fetching all Lists', error);
      swymEmptyMessage(document.querySelector('#wishlist-items-container-all'));
    };

    const searchObj = window.Shopify.theme.helpers.getUrlSearchObj();

    // render a single wishlist collection
    if (searchObj && !searchObj['hkey'] && searchObj['listId']) {
      updateSearchLinks();
      swat.fetchListDetails({ lid: searchObj['listId'] }, onListSuccess, onError);

      // render a shared wishlist
    } else if (searchObj && (searchObj['hkey'] || searchObj['lid'] || searchObj['public-list-id'])) {
      updateSearchLinks();

      // public-list-id: links generated by Swish itself
      const listId = searchObj['lid'] || searchObj['hkey'] || searchObj['public-list-id'];
      swat.fetchListDetails({ lid: listId, shared: true }, onSharedListSuccess, onError);

      // render "all items" wishlist
    } else {
      swat.fetchLists({
        callbackFn: onSuccessAll,
        errorFn: onError,
        withProducts: true,
      });
    }
  }

  function registerWishlistSwymCallbacks() {
    window.SwymCallbacks = window.SwymCallbacks || [];

    const wishlistContainerAll = document.querySelector('#wishlist-items-container-all');
    if (wishlistContainerAll) {
      window.SwymCallbacks.push(swymRenderAll);
      return;
    }

    const wishlistContainerHome = document.querySelector('#wishlist-items-container-home');
    if (wishlistContainerHome) {
      window.SwymCallbacks.push(swymRenderHome);
    }
  }

  function initWishlistPage() {
    const wishlistContainerAll = document.querySelector('#wishlist-items-container-all');
    const wishlistContainerHome = document.querySelector('#wishlist-items-container-home');
    const containerEl = wishlistContainerAll || wishlistContainerHome;

    if (!containerEl) {
      return;
    }

    if (preferencesCookiesNotAllowed()) {
      swymShowCookieConsentPageMessage(containerEl);
      return;
    }

    registerWishlistSwymCallbacks();
  }

  const wishlistPageContainer =
    document.querySelector('#wishlist-items-container-all') ||
    document.querySelector('#wishlist-items-container-home');

  if (wishlistPageContainer && typeof Shopify?.loadFeatures === 'function') {
    Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      () => {
        initWishlistPage();
      }
    );
  } else if (wishlistPageContainer) {
    initWishlistPage();
  }
})();
